import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { V1ContractService } from './v1-contract.service';
import { CommonService } from './common.service';
import { StorageService } from './storage.service';

@Injectable({
  providedIn: 'root'
})
export class MigrationContractService {
  provider: string;
  constructor(private v1ContractService: V1ContractService, private commonService: CommonService, private storageService: StorageService) {
    this.provider = JSON.parse(this.storageService.getItem('account')) != null ? JSON.parse(this.storageService.getItem('account')).provider : "";
   
  }

  async getAddress() {
    const address = environment.MIGRATOR_ADDRESS;
    return address;
  }

}